import { render, staticRenderFns } from "./PrivacyContent.vue?vue&type=template&id=861f3ea4&"
import script from "./PrivacyContent.vue?vue&type=script&lang=ts&"
export * from "./PrivacyContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports